export default __webpack_public_path__ + "static/media/music_rehearsal.b41522dd.jpg";